import {
  AssetVizCompartmentsDisplayState,
  AssetVizHeatmapDisplayState,
} from '@asset-viz/defines'
import { ClipConfig } from '@asset-viz/systems/clipConfig'
import { GeckoInspectionType } from 'types'

export const TYPE_TO_METHOD_TITLE: Partial<
  Record<GeckoInspectionType, string>
> = {
  rug: 'Rapid Ultrasonic Gridding (RUG) Examination',
  raut: 'Rapid AUT Examination',
  trilat: 'Tri-Lateral Examination',
  'phased-array': 'PAUT Examination of Welds',
}

export const TYPE_TO_SHORT_NAME: Partial<Record<GeckoInspectionType, string>> =
  {
    rug: 'RUG',
    raut: 'RAUT',
    trilat: 'TRI-LAT',
    'phased-array': 'PAUT',
  }

export const TYPE_TO_PROCEDURE: Partial<Record<GeckoInspectionType, string>> = {
  raut: 'GR-UT-003 Rev.1',
  trilat: 'GR-UT-004 Rev.0',
  'phased-array': 'GR-UT-005 Rev.0',
}

/**
 * Default messages for various operations
 */
export const MESSAGES = {
  SUCCESS: {
    SAVE: 'Successfully saved changes',
    PUBLISH: 'Successfully published revision',
    GENERATE: 'Successfully generated PDF',
    REVERT: 'Successfully reverted to Cantilever values',
  },
  ERROR: {
    SAVE: 'Failed to save changes',
    PUBLISH: 'Failed to publish revision',
    GENERATE: 'Failed to generate PDF',
    REVERT: 'Failed to revert to Cantilever values',
    LOAD: 'Failed to load data',
  },
  CONFIRM: {
    PUBLISH: 'Are you sure you want to publish this revision?',
    REVERT: 'Are you sure you want to revert to Cantilever values?',
  },
} as const

/**
 * Default configuration for Asset Visualization
 */
export const ASSET_VIZ_DEFAULT_CONFIG = {
  show3D: true,
  showRulers: true,
  heatmapDisplayState: AssetVizHeatmapDisplayState.Sharp,
  showFeatures: true,
  showCompass: false,
  showFeatureLabels: false,
  compartmentsDisplayState: AssetVizCompartmentsDisplayState.NominalPlates,
  showStructures: true,
  showHtmlOverlayDebugColors: false,
  showDebugStats: false,
  showFeatureDebugColors: false,
  showShellCourseDebugColors: false,
  showPlateFeatureDebugColors: false,
  showBinValues: false,
  showLegend: true,
  overrideCameraAspectRatio: { current: -1 },
  force11x7AspectRatio: false,
  stretchAssetToFitScreen: false,
  invertColors: false,
  heatmapOpacity: 1,
  assetOpacity: 1,
  clipConfig: new ClipConfig(),
  activePhotogrammetryModel: undefined,
  activePhotogrammetryTexture: undefined,
  setPhotogrammetryTextureLoading: undefined,
  showPhotogrammetryTexture: false,
  hasPhotogrammetryTextureUpdates: false,
} as const
